import { nlToArr } from '../../../vendorjs/helpers/nodeList';

window.Alpine.data('accordion', (data) => {
  return {
    $items: null,
    openAccordions: [],
    allowMultiple: null,

    init() {
      this.allowMultiple = data && !!data.allowMultiple;
      this.$items = nlToArr(this.$root.querySelectorAll('.accordion--item'));
    },

    isOpen() {
      return this.isNodeOpen(this.$el);
    },

    toggle() {
      const index = this.getItemIndex(this.getParentItem(this.$el));
      this.toggleIndex(index);
    },

    toggleIndex(index) {
      const isOpen = this.isIndexOpen(index);

      if (this.allowMultiple) {
        if (isOpen) {
          const indexInOpenAccordions = this.openAccordions.indexOf(index);
          this.openAccordions.splice(indexInOpenAccordions, 1);
        } else {
          this.openAccordions.push(index);
        }
      } else {
        this.openAccordions = isOpen ? [] : [index];
      }
    },

    isNodeOpen($node) {
      const index = this.getItemIndex(this.getParentItem($node));
      return this.isIndexOpen(index);
    },

    isIndexOpen(index) {
      return this.openAccordions.includes(index);
    },

    getItemIndex($itemNode) {
      return this.$items.indexOf($itemNode);
    },

    getParentItem($el) {
      return $el.closest('.accordion--item');
    },
  };
});
